import { render, staticRenderFns, recyclableRender, components } from "./shop-index.vue?vue&type=template&id=4dfa1c66&scoped=true&"
var renderjs
import script from "./shop-index.vue?vue&type=script&lang=js&"
export * from "./shop-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../办公/HBuilderX.3.8.12.20230817/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa1c66",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/shop-index/shop-index.vue"
export default component.exports